export const SIDE_MENU_ATTRIBUTE = 'data-menu-open';
